module.exports = __webpack_public_path__ + "img/SAS_WoodenKiteShield.3887a7cc.png";